<template>
  <section id="mainContent">
    <div class="card-wrapper" v-if="annoucements.length">
        <div v-for="(e, index) in annoucements" :key="index" class="annoucement-card">
            <div v-if="e.companyStatementType === 2 " class="tag-statement-urgency">
                {{ e.companyStatementTypeStr }}
            </div>
            {{ e.title | limitTo(20) }}

            <div class="annoucement-reactions-photos-wrapper">
                <div v-for="(user, index) in e.users" :key="index">
                    <div v-if="index < 5" class="annoucement-reaction">
                        <div v-if="user.photo" class="annoucement-reactions-photos" >
                            <img :src="user.photo">
                            <div class="reaction-bg">
                                <img v-if="user.companyStatementReactSelected === 0" />
                                <img v-if="user.companyStatementReactSelected === 1" class="reaction-image" src="../../../../assets/img/reactions/thumbs_up.svg"/>
                                <img v-if="user.companyStatementReactSelected === 2" class="reaction-image" src="../../../../assets/img/reactions/heart.svg"/>
                                <img v-if="user.companyStatementReactSelected === 3" class="reaction-image" src="../../../../assets/img/reactions/clap.svg"/>
                                <img v-if="user.companyStatementReactSelected === 4" class="reaction-image" src="../../../../assets/img/reactions/white_check_mark.svg"/>
                                <img v-if="user.companyStatementReactSelected === 5" class="reaction-image" src="../../../../assets/img/reactions/-1.svg"/>
                            </div>
                        </div>
                        <div v-else class="annoucement-reactions-without-photos">
                            <div class="annoucement-reaction-initials">
                                {{ getNameInitials(user.name) }}
                            </div>
                            <div class="reaction-bg">
                                <img v-if="user.companyStatementReactSelected === 0" />
                                <img v-if="user.companyStatementReactSelected === 1" class="reaction-image" src="../../../../assets/img/reactions/thumbs_up.svg"/>
                                <img v-if="user.companyStatementReactSelected === 2" class="reaction-image" src="../../../../assets/img/reactions/heart.svg"/>
                                <img v-if="user.companyStatementReactSelected === 3" class="reaction-image" src="../../../../assets/img/reactions/clap.svg"/>
                                <img v-if="user.companyStatementReactSelected === 4" class="reaction-image" src="../../../../assets/img/reactions/white_check_mark.svg"/>
                                <img v-if="user.companyStatementReactSelected === 5" class="reaction-image" src="../../../../assets/img/reactions/-1.svg"/>
                            </div>
                        </div>
                    </div>
                    <div v-else class="remaining-reactions-qty">
                        + {{ e.qtdReact - 5 }}
                    </div>
                </div>

            </div>
            <div class="button-see-annoucement-wrapper">
                <router-link :to="`/detalhes-do-comunicado/${e.id}`" class="see-annoucement-link">
                    <p>Ver comunicado</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <rect width="20" height="20" rx="10" fill=""/>
                        <path d="M18.125 10C18.125 5.51289 14.4871 1.875 10 1.875C5.51289 1.875 1.875 5.51289 1.875 10C1.875 14.4871 5.51289 18.125 10 18.125C14.4871 18.125 18.125 14.4871 18.125 10ZM9.81836 13.5687C9.76008 13.5109 9.71375 13.4422 9.68203 13.3665C9.65031 13.2908 9.63382 13.2096 9.63349 13.1275C9.63316 13.0454 9.64901 12.964 9.68013 12.8881C9.71125 12.8121 9.75702 12.743 9.81484 12.6848L11.8586 10.625H6.64062C6.47486 10.625 6.31589 10.5592 6.19868 10.4419C6.08147 10.3247 6.01562 10.1658 6.01562 10C6.01562 9.83424 6.08147 9.67527 6.19868 9.55806C6.31589 9.44085 6.47486 9.375 6.64062 9.375H11.8586L9.81484 7.31523C9.75703 7.25691 9.71127 7.18777 9.68018 7.11176C9.64909 7.03575 9.63327 6.95436 9.63364 6.87224C9.634 6.79012 9.65053 6.70887 9.6823 6.63314C9.71406 6.55741 9.76042 6.48867 9.81875 6.43086C9.87708 6.37305 9.94622 6.32729 10.0222 6.2962C10.0982 6.26511 10.1796 6.24929 10.2617 6.24965C10.4276 6.25039 10.5864 6.31697 10.7031 6.43477L13.8043 9.55977C13.9205 9.67683 13.9857 9.83507 13.9857 10C13.9857 10.1649 13.9205 10.3232 13.8043 10.4402L10.7031 13.5652C10.6453 13.6236 10.5765 13.6701 10.5007 13.7018C10.425 13.7336 10.3437 13.7502 10.2615 13.7505C10.1793 13.7508 10.0979 13.7349 10.0218 13.7038C9.94578 13.6726 9.87664 13.6267 9.81836 13.5687Z" fill="#1B59F8"/>
                    </svg>
                </router-link>
            </div>
        </div>
    </div>

    <div v-if="!annoucements.length && !this.isLoading">
        <p class="nunito">Você ainda não nenhum comunicado até o momento.</p>
        <img src="/src/assets/img/empty/solicitações.png" class="img-responsive" alt="sem solicitação"/>
    </div>
  </section>
</template>

<script>

export default {
    name: 'annoucementsCards',
    props: {
        annoucements: {
            type: Array,
            required: true,
            default: []
        },
        isLoading: {
            type: Boolean,
        }
    },
    data() {
        return {
        }
    },
    methods: {
        getNameInitials (name) {
            const regex = /\b[A-Za-z]/g;
            const initials = (name.match(regex) || []).map(initial => initial.toUpperCase()).slice(0, 2).join('');
            return initials;
        },
    }
}
</script>

<style lang="scss">
    .card-wrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 30px 30px;
        justify-content: flex-start;
        align-items: center;

        .annoucement-card {
            display: flex;
            position: relative;
            justify-content: space-between;
            align-self: flex-start;
            border: 1px solid var(--borderGray);
            border-radius: 10px;
            width: 347px;
            height: 86px;
            padding: 10px;
            color: var(--text);
            font-weight: 600;
            font-size: 16px;
            z-index: 1;
            transition: transform 0.5s;

            .tag-statement-urgency {
                position: absolute;
                top: -8px;
                right: 20px;
                padding: 0px 8px 1px 8px;
                justify-content: center;
                background: #FF445D;
                border-radius: 10px;

                font-family: Montserrat;
                font-size: 10px;
                font-style: normal;
                font-weight: 400;
                line-height: 140.625%;
                color: #FFF;
            }

            .annoucement-reactions-photos-wrapper {
                transition: 0.5s;
                position: absolute;
                bottom: -18px;
                left: 25px;
                display: flex;
                flex-direction: row-reverse;
                cursor: pointer;

                .annoucement-reaction {
                    position: relative;
                    margin-left: -11px;
                }

                .annoucement-reactions-photos {
                    height: 35px;
                    width: 35px;
                    min-width: 35px;
                    position: relative;

                    img {
                        transition: 0.5s;
                        margin: 0;
                        object-fit: cover;
                        border: 3.167px solid var(--bodyColor2);
                        border-radius: 35.436px;
                        width: 100%;
                        height: 100%;
                        background: var(--bodyColor2);
                    }

                    .reaction-bg {
                        transition: 0.5s;
                        position: absolute;
                        bottom: 23px;
                        left: 2px;
                        margin: 0;
                        border: 3px solid var(--bodyColor2);
                        border-radius: 20px;
                        z-index: 999;
                        background: var(--bodyColor2);
                        text-align: center;
                        display: flex;
                        align-items: center;

                        .reaction-image {
                            background: var(--bodyColor2);
                            width: 12px;
                            height: auto;
                            border-radius: 0;
                            border: none;
                        }
                    }
                }

                .annoucement-reactions-without-photos {
                    height: 35px;
                    width: 35px;
                    min-width: 35px;
                    position: relative;

                    .annoucement-reaction-initials {
                        transition: 0.5s;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 3px solid var(--bodyColor2);
                        border-radius: 35px;
                        width: 100%;
                        height: 100%;
                        background: #d9d9d9;
                        color: #FFF;
                        font-family: Montserrat;
                        font-size: 11.875px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: normal;
                    }

                    .reaction-bg {
                        transition: 0.5s;
                        position: absolute;
                        bottom: 23px;
                        left: 2px;
                        margin: 0;
                        border: 3px solid var(--bodyColor2);
                        border-radius: 20px;
                        z-index: 999;
                        background: var(--bodyColor2);
                        text-align: center;
                        display: flex;
                        align-items: center;
                        .reaction-image {
                            width: 12px;
                            height: auto;
                        }
                    }

                }
            }

            .remaining-reactions-qty {
                transition: 0.5s;
                color: var(--text);
                position: absolute;
                right: -20px;
                bottom: 8px;
                font-size: 11px;
                font-style: normal;
                font-weight: 600;
                z-index: -1;
                padding: 2px;
                background: var(--leftMenuColor);
                text-align: center;
            }
        }

        .annoucement-card:hover {
            transform: scale(1.05)
        }

        .button-see-annoucement-wrapper {
            display: flex;
            align-items: center;
            align-self: flex-end;
            justify-self: flex-end;
            color: var(--darkBlue);
            font-size: 12px;
            font-weight: 400;
            line-height: 140.625%;
            gap: 4px;

            .see-annoucement-link {
                display: flex;
                gap: 2px;
                
                svg path {
                    fill: var(--darkBlue);
                }
            }

            p {
                margin: 0;
                align-self: flex-end;
                justify-self: flex-end;
                color: var(--darkBlue);
                font-size: 12px;
                font-weight: 400;
                line-height: 140.625%;
                white-space: nowrap;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/vue/views/components/layouts/annoucementsCards.vue